export const formatPayload = (formDetails) => {
  const { actionable = "", documentType = "" } = formDetails;

  if (formDetails?.typeOfVendor === "Existing") {
    return {
      actionable: actionable,
      documentType: documentType,
      typeOfVendor: "EXISTING",
      vendorId: formDetails.vendor.id,
      originalAgreement: formDetails.originalAgreement,
      supportingDocument1: formDetails.supportingDocument1,
      supportingDocument2: formDetails.supportingDocument2,
    };
  } else {
    return {
      nameOfVendor: formDetails.nameOfVendor,
      actionable: actionable,
      documentType: documentType,
      typeOfVendor: "NEW",
      originalAgreement: formDetails.originalAgreement,
      supportingDocument1: formDetails.supportingDocument1,
      supportingDocument2: formDetails.supportingDocument2,
      addressOfVendor: formDetails.addressOfVendor,
      emailIdOfVendor: formDetails.emailIdOfVendor,
      timeForPaymentOfInvoiceSubmission:
        formDetails.timeForPaymentOfInvoiceSubmission,
      panCard: formDetails.panCard,
      gstCertificate: formDetails.gstCertificate,
      aadharUpload: formDetails.aadharUpload,
    };
  }
};
